




































































































































import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import util from '@/components/util';
import SearchBox from '@/components/util/SearchBoxV3.vue';
import { strFuzzyMatch } from '@/class/common/util';
import BasicGadget, {CFrame} from '@/components/gadgets/BasicGadget.vue';
import * as models from '@/class/models/views/graph';
import Gadgets from '@/components/gadgets';
import InfiniteLoading from 'vue-infinite-loading';

const SP_INFINITE_LOAD_NUM = 5; // SP表示の無限ローディングで何件ずつ読み込むか

interface Data {
  searchValue: string;
  selectGadgets: models.IGadget[];
  componentGadgets: any;
  frameDataDefault: CFrame;
  frameDataDefaultSP: CFrame;
  frameDataSample: CFrame;
  frameDataSampleSP: CFrame;
  actives: string[];
  selectCardNum: string[];
  largeGadget: models.IGadget;
  largeGadgetActive: string;
  isShowLargeGadget: boolean;
  titleList: Array<{
    id: 'sample' | 'kojin';
    title: string;
    number: number;
  }>;
  loading: boolean;
  spDispGadgetList: {
    sample: models.IGadget[];
    kojin: models.IGadget[];
  };
}

interface Methods {
  handleResize: () => void;
  isMatch: (title: string) => boolean;
  infiniteHandler: ($state: any) => void;
  onClickGadget: (select: models.IGadget, key: any) => void;
  onClickGadgetEdit: (select: models.IGadget) => void;
  onClickGadgetDelete: (gadgetID: number) => void;
  resetSelectGadget: () => void;
  onClickGadgetAdd: () => void;
  generateModal: () => void;
  getGadgetName: (gadgetName: string) => string;
  showLargeGadget: (gadget: models.IGadget, active: string) => void;
}

interface Computed {
  DISP_LIST: {
    sample: models.IGadget[];
    kojin: models.IGadget[];
    share: never[];
  };
  ACTIVE: {
    sample: boolean;
    kojin: boolean;
  };
}

interface Props {
  gadgets: models.IGadget[];
  settings: any;
  addGadgetLock: (addNum?: number) => boolean;
}

export interface ISettings {
  edit: boolean;
  add: boolean;
  tab: boolean;
}

export class CSettings implements ISettings {
  public edit = false;
  public add  = false;
  public tab = false;
}

export default Vue.extend({
  name: 'GadgetListV3',
  components: {
    ...util,
    SearchBox, BasicGadget, InfiniteLoading,
  },
  props: {
    gadgets: Array as PropOptions<models.IGadget[]>,
    settings: {
      type: Object as () => ISettings,
      default: () => new CSettings(),
    },
    addGadgetLock: {
      type: Function,
    },
  },
  data() {
    return {
      searchValue: '',
      selectGadgets: [] as models.IGadget[], // 送るガジェットが複数になる
      componentGadgets: Gadgets,
      frameDataDefault: new CFrame(),
      frameDataDefaultSP: new CFrame(),
      frameDataSample: new CFrame(),
      frameDataSampleSP: new CFrame(),
      actives: [] as string[],
      selectCardNum: [] as string[],
      largeGadget: {} as models.IGadget,
      largeGadgetActive: '',
      isShowLargeGadget: false,
      titleList: [
        {
          id: 'sample',
          title: 'サンプルグラフを表示',
          number: 1,
        },
        {
          id: 'kojin',
          title: '作成グラフを表示',
          number: 2,
        },
      ],
      loading: false,
      spDispGadgetList: {
        sample: [] as models.IGadget[],
        kojin: [] as models.IGadget[],
      },
    };
  },
  computed: {
    DISP_LIST() {
      // REMOLABO-413 フィルタリングをCSSで行う方法に変更（マッチしない場合hiddenクラスを付与）
      // const gadgets: models.IGadget[] = this.searchValue
      //   ? this.gadgets.filter((v) => strFuzzyMatch(this.searchValue, v.title))
      //   : this.gadgets;
      const gadgets = this.gadgets;
      const returnGadgets = {
        sample: gadgets.filter((v) => (v.default)),
        kojin: gadgets.filter((v) => (!v.default)),
        share: [],
      };
      // console.log(this.tab);
      return returnGadgets;
    },
    ACTIVE() {
      return {
        sample: this.actives.some((v) => v === 'sample'),
        kojin: this.actives.some((v) => v === 'kojin'),
      };
    },
  },
  created() {
    // 画面サイズ変更時にhandleResizeを呼び出す
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // イベントリスナーを削除する
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    // this.frameData.show = false;
    // PC
    this.frameDataDefault.cover = true;
    this.frameDataSample.cover = true;
    this.frameDataSample.sample = true;
    // SP
    this.frameDataDefaultSP.cover = true;
    this.frameDataDefaultSP.noicons = true;
    this.frameDataSampleSP.cover = true;
    this.frameDataSampleSP.sample = true;
    this.frameDataSampleSP.noicons = true;

    this.actives = this.titleList.map((v) => v.id);
  },
  methods: {
    handleResize() {
      // PCサイズからSPサイズに縮小したときにInfiniteLoadingを発火させる
      window.dispatchEvent(new Event('scroll'));
    },
    isMatch(title: string) {
      return this.searchValue.length ? strFuzzyMatch(this.searchValue, title) : true;
    },
    onClickGadget(select: models.IGadget, key: any ) {
      // 配列へ追加/削除
      if (this.selectCardNum.includes(key)) { // 削除
        const index = this.selectCardNum.indexOf(key);
        const gadIndex = this.selectGadgets.indexOf(select);
        if ((index > -1) && (gadIndex > -1)) {
          this.selectCardNum.splice(index, 1);
          this.selectGadgets.splice(gadIndex, 1);
        }
      } else { // 追加
        this.selectCardNum.push(key);
        this.selectGadgets.push(select);
      }
    },
    onClickGadgetEdit(select: models.IGadget) {
      this.$emit('edit', select);
      this.$emit('close');
    },
    onClickGadgetDelete(gadgetID: number) {
      this.$emit('delete', gadgetID);
    },
    // 選択をリセットする
    resetSelectGadget() {
      this.selectCardNum.splice(0);
      this.selectGadgets.splice(0);
    },
    async onClickGadgetAdd() {
      if (this.addGadgetLock(this.selectGadgets.length - 1)) {
        this.$emit('info', 'タブ内にグラフは13個以上登録できません。');
        return;
      }
      for (const gadget of this.selectGadgets) {
        this.$emit('add', gadget);
        // gadgetnumberを一意にするため時間をずらす
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      this.$emit('registview');
      window.scrollTo(0, 0);
      this.$emit('close');
    },
    // onDragStartGadget(gadget: models.IGadget) {
    //   this.$emit('holding', gadget);
    // },
    // onDragEndGadget() {
    //   this.$emit('holding', {});
    // },
    generateModal() {
      this.$emit('generate');
    },
    getGadgetName(gadgetName: string) {
      // 第二次デザインで作られたグラフは新旧デザインを切り替える
      // 第三次デザインで作られたグラフはそのまま表示
      return gadgetName.indexOf('V3') === -1 ? gadgetName + 'V3' : gadgetName;
    },
    showLargeGadget(gadget: models.IGadget, active: string) {
      this.largeGadget = gadget;
      this.largeGadgetActive = active;
      this.isShowLargeGadget = true;
    },
    async infiniteHandler($state: any) {
      // 無限ローディング対策
      if (!this.loading) {
        this.loading = true;

        // 現在表示しているガジェット数
        let sampleShowLength = this.spDispGadgetList.sample.length;
        let kojinShowLength = this.spDispGadgetList.kojin.length;
        // 各種類の全件数
        const sampleLength = this.DISP_LIST.sample.length;
        const kojinLength = this.DISP_LIST.kojin.length;

        // sampleから切り出し
        const isSample = this.actives.some((v) => v === 'sample');
        const isKojin = this.actives.some((v) => v === 'kojin');
        if (isSample && sampleShowLength < sampleLength) {
          const sampleList = this.DISP_LIST.sample.slice(sampleShowLength, sampleShowLength + SP_INFINITE_LOAD_NUM);
          this.spDispGadgetList.sample = this.spDispGadgetList.sample.concat(sampleList);
          sampleShowLength = this.spDispGadgetList.sample.length;
        }
        // kojinから切り出し
        if (isKojin && kojinShowLength < kojinLength) {
          if (!isSample || sampleShowLength === sampleLength) {
            const kojinList = this.DISP_LIST.kojin.slice(kojinShowLength, kojinShowLength + SP_INFINITE_LOAD_NUM);
            this.spDispGadgetList.kojin = this.spDispGadgetList.kojin.concat(kojinList);
            kojinShowLength = this.spDispGadgetList.kojin.length;
          }
        }
        let isComplete = false;
        if (isKojin) {
          // 作成グラフONで全て表示されていればcomplete
          isComplete = (kojinShowLength === kojinLength);
        } else {
          // サンプルグラフONで作成グラフOFFならサンプルグラフ全表示でcomplete
          // 何も選択していなければcomplete
          isComplete = isSample ? (sampleShowLength === sampleLength) : true;
        }
        // await this.$nextTick();
        if (isComplete) {
          $state.complete();
        } else {
          // setTimeout(() => {
          $state.loaded();
          // }, 2000);
        }
        this.loading = false;
      }
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);

